import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { useContent } from 'hooks';
import { CustomSVG } from 'components';

const styles = ({ custom, palette, spacing }: Theme) =>
  createStyles({
    text: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 6,
      paddingBottom: 6,
      color: palette.common.white,
    },
    important: {
      backgroundColor: custom.palette.orange,
    },
    importantToShare: {
      backgroundColor: palette.primary.main,
    },
    importantIcon: {
      marginRight: spacing(1),
    },
    shareIcon: {
      display: 'flex',
      alignItems: 'center',
      marginRight: spacing(1),
      backgroundColor: palette.common.white,
      color: palette.primary.main,
    },
  });

const Important: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { is_important, important_to_share } = useContent();

  if (important_to_share) {
    const textClasses = classNames(classes.text, classes.importantToShare);

    return (
      <Grid container alignItems="center" justify="center">
        <Grid item xs>
          <Typography align="center" variant="subtitle2" className={textClasses}>
            <span className={classes.shareIcon}>
              <CustomSVG name="share" size={16} />
            </span>
            <Trans i18nKey="content:recommendedToShare" />
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (is_important) {
    const textClasses = classNames(classes.text, classes.important);

    return (
      <Grid container alignItems="center" justify="center">
        <Grid item xs>
          <Typography align="center" variant="subtitle2" className={textClasses}>
            <CustomSVG className={classes.importantIcon} name="important" size={16} />
            <Trans i18nKey="common:important" />
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default withStyles(styles)(Important);
